export function Logo({ variant = "dark", className = "h-11 w-auto" }) {
    return (
        <img
            src={variant === "light" ? "/star-logo-light.png" : "/star-logo-dark.png"}
            alt="Star USA"
            className={`object-contain ${className}`}
            data-testid="star-logo"
        />
    );
}

export function LogoMark({ className = "h-10 w-10" }) {
    return (
        <img
            src="/favicon.png"
            alt="Star USA mark"
            className={`object-contain ${className}`}
            aria-hidden="true"
        />
    );
}
